export const iconFontAwesomeMoneyStamp = (
	<i className="fa-solid fa-stamp"></i>
);
